import React from 'react';
import { Pagination, Stack } from '@mui/material';

const AppPagination = ({ count, currentPage, onChange }) => {
    // Si une seule page ou aucune, on n'affiche rien du tout
    if (!count || count <= 1) return null;

    const handleChange = (event, value) => {
        if (typeof onChange === 'function') {
            onChange(value);
        }
    };

    return (
        <Stack 
            spacing={2} 
            sx={{ 
                width: '100%', 
                alignItems: 'flex-end', // Aligne à gauche
                py: 4 
            }}
        >
            <Pagination 
                count={count} 
                page={currentPage} 
                onChange={handleChange} 
                variant="outlined" 
                shape="rounded" 
                color="primary"
                sx={{
                    // Cibler le bouton de la page sélectionnée (Mui-selected)
                    '& .MuiPaginationItem-root.Mui-selected': {
                        backgroundColor: '#4318FF', // Ta couleur (ex: bleu royal)
                        color: '#fff',               // Texte en blanc
                        border: 'none',
                        '&:hover': {
                            backgroundColor: '#3311CC', // Couleur un peu plus sombre au survol
                        }
                    },
                    // Optionnel : style des boutons non sélectionnés au survol
                    '& .MuiPaginationItem-root:not(.Mui-selected):hover': {
                        backgroundColor: '#F4F7FE',
                    }
                }}
            />
        </Stack>
    );
};

export default AppPagination;